import { AlertTriangle } from "lucide-react";

// Shared bulk-delete confirmation modal (used by Payments & Orders).
export default function ConfirmDeleteModal({ open, count, noun = "record", busy = false, onCancel, onConfirm, testid = "confirm-delete" }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onCancel}>
      <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-2xl w-full max-w-md" data-testid={`${testid}-modal`}>
        <div className="p-6 flex flex-col items-center text-center gap-3">
          <div className="h-12 w-12 rounded-full bg-red-100 text-red-600 flex items-center justify-center"><AlertTriangle size={24} /></div>
          <h2 className="font-heading text-lg font-bold text-zinc-900">Delete {count} {noun}{count === 1 ? "" : "s"}?</h2>
          <p className="text-sm text-zinc-500">Are you sure you want to delete the selected records? This action cannot be undone.</p>
        </div>
        <div className="p-5 border-t border-zinc-100 flex gap-3">
          <button onClick={onCancel} disabled={busy} data-testid={`${testid}-cancel`} className="flex-1 h-12 rounded-xl border border-zinc-200 font-semibold disabled:opacity-50">Cancel</button>
          <button onClick={onConfirm} disabled={busy} data-testid={`${testid}-confirm`} className="flex-1 h-12 rounded-xl bg-red-500 hover:bg-red-600 text-white font-semibold disabled:opacity-50">{busy ? "Deleting…" : "Delete"}</button>
        </div>
      </div>
    </div>
  );
}
